module.exports = {

	language: {
		name: 'English'
	},
	
	header: {
		1: 'Link wallet',
		2: 'Home',
		3: 'About ',
		4: 'Function ',
		5: 'Appointment ',
		6: 'Mode ',
		7: 'Safe'
	},
	indexyx: {
	1: 'Valla phone invites you to share this vast blue ocean ',
	2: 'Will launch the first phase of the airdrop program worth $500W with the industry leader POWERED BPOUVERED B Star Project ',
	3: "Pay",
	4: "Invitation List ",
	5: "Number ",
	6: "Address",
	7: "Web3 Pioneers of the New Generation ",
	8: "Smartphones designed for multi-chain ecosystems ",
	9: "Anticipated ",
	10: "year ",
	11: "Market value ",
	12: "Will soar to ",
	13: "Ten thousand ",
	14: "Billion dollars ",
	15: "The best entry point to the Web3 world for a mobile ecosystem tailored for multi-chain ecosystems ",
	16:"Recharge successful",
		17:"Recharge failed",
		18:"Insufficient balance",
	},
	indexfl:{
	1:"Valla phone invites you to share this vast blue ocean ",
	2:"FLOKI Token is a cryptocurrency that originally originated as a community-driven project. The name and brand of FLOKI are inspired by the name of ElonMusk's pet dog, the founder of the famous cryptocurrency Dogecoin, and its image is very popular with the community. FLOKI, as a community-led project to modify Dogecoin, aims to build a broad ecosystem with multiple different features and applications. ",
	3:" What is Vallhal&Valla phone?" ,
	4:"FLOKI Token is a cryptocurrency that originally originated as a community-driven project. The name and brand of FLOKI are inspired by the name of ElonMusk's pet dog, the founder of the famous cryptocurrency Dogecoin, and its image is very popular with the community. FLOKI, as a community-led project to modify Dogecoin, aims to build a broad ecosystem with multiple different features and applications. ",
	5:"VALHALLA, Floki's first meta-universe game, aims to build the world's most successful crypto game by bringing a fun and innovative game to the world's largest gaming market." ,
	6:"Valla phone is the first 'AI flagship phone' in the Web3 field launched by Valhalla. Through wb3 mobile phone users can better enter the world of the meta-universe, and through innovation and exploration of DePIN, the release of the potential of AI will bring Web3 devices into a new development path. It also provides Valhalla users with seamless cryptocurrency management, decentralized application (DApp) access, and a full-chain gaming experience. It also meets the needs of different users in decentralized finance (DeFi), NFT and Web3 application scenarios." ,
	
	},
	indexfz:{
	1:" Mobile phone development Trajectory ",
	2:" From 'Brick' to Web3, mobile phones have undergone a huge change, and Vallaphone is leading the wave into the future. Are you ready to join the revolution?",
	3:" Back in the 1980s, when the first mobile phone, the MOTOROLA DynaTAC, came out! Although this 'brick' phone was bulky and expensive, it was an epoch-making breakthrough at the time. What rapid progress!" ,
	4:" Time flies, and now cell phones are more than just tools for making calls. Vallaphone is here to lead the next wave of mobile innovation, incorporating Web3, decentralized technology, and privacy-first features." ,
	5:" From carrying 'bricks' to owning a secure Web3 phone that earns tokens, the future of mobile has arrived.' Vallaphone is not just a device, it's an entry point into the world of decentralized technology." ,
	6:" From its beginnings as a bulky, sluggish device to today's thin, fast, and secure technology, Vallaphone not only keeps you connected, it puts you in control." ,
	},
	indexsj:{
	1:"Web3 chain phone Valla phone",
	2:" Agent Mode ",
	3:" Phone price :",
	4:" Ministry ",
	5:" First batch ",
	6:" Station ",
	7:" After the station ",
	8:" Agent interest :",
	9:"1. Recommender sends 1000u worth of Floki 3 ‰ release ",
	10:"1. Agents sell 300 mobile phones and directly reward the value of 300,000 cars/rooms or cash (agents must book 10 mobile phones at one time in the application process)",
	11:"2. The agent's mobile phone can be handled by itself for secondary sales ",
	12:" Sales Model ",
	13:"1. One mobile phone, the delivery cycle is about two months." ,
	14:"2. Buyer sends 1000u Floki3/10000 release. " ,
	15:"3. Airdrop no less than 50 high-quality projects invested by institutions within one year after getting the phone." ,
	16:"4. The Valhalla official first 500 mobile phones each drop 1000 Val platform tokens on the launch, according to the decreasing price of the gift (500 after the launch) unlimited value." ,
	17:"5. The agent sells 300 mobile phones and directly rewards the value of 300,000 cars or houses or cash (the agent application process must book 10 mobile phones at one time, and the mobile phone can also be handled by the second sales.) ",
	18:" First batch ",
	},
	indexzs:{
	1:" Functional Highlights ",
	2:" Launch the first phase of the airdrop plan worth $500W in conjunction with the industry's leading enterprise star project ",
	3:" Smooth flow ",
	4:" Intelligence ",
	5:" Play around ",
	6:" Design for a Web3 world by integrating Ai and Web3 Technologies ",
	7:" Powered by Android ",
	8:"Invitation Token Reward",
9:"Number of Inviters",
10:"Direct",
11:"Indirect",
12:"Withdraw",
13:"Invitation Record",
14:"Time",
15:"Type",
16:"Quantity",
17:"Withdrawal Success",
18:"Withdrawal Failed",
19: "Balance",
20: "Please enter the withdrawal amount",
21: "Insufficient balance",
22: "Pay",
23: "Reward",
24: "Withdraw",
25: "Price",
26: "My",
27: "My Purchase",
28:'Not open'
	
	},
	indexjc:{
	1:" Integrated decentralized applications ",
	2:" Experience the web3 world seamlessly ",
	3:"Valla phone is not only a multi-chain wallet, but also a platform that fully integrates with the decentralized application (DApp) ecosystem.' Users can access a wide range of decentralized applications directly from Valla phone, without having to download and switch multiple applications, which greatly improves the user experience." ,
	4:"DAPP Ecological Integration ",
	5:" Users can access the supported Dapps directly within Vallaphone, covering DeFi, NFT, games, social and other user experiences will no longer be limited to traditional browser or wallet applications." ,
	6:"Web3 Integrated Experience ",
	7:" Not only supports decentralized applications, Vallaphone also provides Web3 based functions, such as decentralized social networking, decentralized financial services, NFT trading platform, etc., to provide users with a comprehensive decentralized ecological experience." ,
	
	},
	aq:{
	1:" Enhanced security ",
	2:" In the cryptocurrency and blockchain space, security has always been one of the biggest concerns for users. Valla phone ensures the highest level of protection for users' digital assets and private information by integrating innovative hardware security modules." ,
	3:" Hardware Wallet integration ",
	4:"Valla phone's built-in hardware security block provides physical isolation for crypto assets, and sensitive information such as private keys and signatures are stored in separate hardware modules, greatly reducing the risk of hacker attacks." ,
	5:" Multi-authentication Mechanism ",
	6:" In addition to traditional PIN codes and fingerprint recognition, MultiAPP supports biometrics, such as facial recognition, as well as secondary verification to further enhance security." ,
	7:" tamper-proof mechanism ",
	8:" The device has built-in tamper-proof hardware to ensure that the user's private keys and sensitive information remain protected if the device is stolen or tampered with." ,
	
	},
	yh:{
	1:" Optimized User experience ",
	2:"Valla phone is committed to providing an intuitive, easy-to-use multi-chain wallet and DApp platform that simplifies the user's operation process and makes cryptocurrency management and cross-chain transactions more convenient." ,
	3:" Simplified cross-chain operation ",
	4:" Users only need to complete the management and transaction of multi-chain assets through a simple few steps, without cumbersome address replication or complex transaction processes.' All operations can be done in a single interface of Vallaphone, which greatly improves user efficiency.",
	5:" Personalization and smart recommendation one-click management of multiple wallets",
	6:" For users who hold multiple crypto assets, Va.phone provides the ability to manage multiple wallets and assets with one click, and users can easily switch and view on different chains, reducing tedious steps.'A'  ",
	
	},

	lucky:{
	1:" The first batch of users full of benefits ",
	2:" Build the world's strongest Wbe3 phone!" ,
	3:" Market Opportunity ",
	4:"Valla phone is committed to providing an intuitive, easy-to-use multi-chain wallet and DApp platform that simplifies the user's operation process and makes cryptocurrency management and cross-chain transactions more convenient." ,
	5:" The next few years will see several important changes in the market, not least the widespread adoption of cryptocurrencies and blockchain technology. With the rapid development of NFT(non-homogeneous Decentralized Finance (DeFi) coins) and Web3 applications, the demand for multi-chain ecosystems will rise sharply among global users. Valla phone, with its innovation in multi-chain technology, is at the forefront of this market explosion.",
	6:" The global multi-chain market is expected to reach $500 billion by 2025 and exceed $1 trillion by 2030." ,
	7:" With the popularization of blockchain technology and the improvement of global user awareness of cryptocurrency, it is expected that the global cryptocurrency users will exceed 500 million.This will drive demand for multi-chain devices, wallets and applications.",
	8:" The market for Web3 and decentralized applications is expected to reach a $5 trillion market cap by 2030, which provides tremendous room for growth for multi-chain phones and ecosystems."
	},
}
